module.exports = __webpack_public_path__ + "static/media/login_header_plate.6829f581.png";